const api = {
  local: 'http://localhost:8080/',
  test: 'http://test.sesam.appliedmethods.biz/',
  qs: 'https://qs-sesam.lmz-bw.de/',
  preprod: 'https://sesam2020.lmz-bw.de/',
  prod: 'https://sesam.lmz-bw.de/'
};

const target = process.env.API && api[process.env.API]
  ? api[process.env.API]
  : api['local'];

module.exports = { target, api };
